(function($) {
    $(function() {
        var $carousel = $('.upt-author-page__book-carousel');
        $carousel.slick({
            dots: false,
            slide: 'div.upt-author-page__book-carousel--book',
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    });
})(jQuery);